import widgetsService from 'live/services/widgets'
import trajectoryReducer from './trajectoryReducer'

import TrajectorySelectView from './actions/TrajectorySelectView'
import fixDisplayUnit from '../common/fixDisplayUnit'
import { addNewEditor } from '../common/editorRegister'
import i18n from 'live/services/i18n'
import thumbnail from '../../../assets/img/survey.png'

import React from 'react'
import './trajectoryLookup'
import { Fields } from '../editor'
import AssetSelector from '../editor/fields/AssetSelector'
import ObjectSelector from '../editor/fields/ObjectSelector'
import { LiveApi } from 'live/lib/api'

import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import SurveyChart from './SurveyChart'

const type = 'survey'

widgetsService.register({
    type,
    get name() {
        return i18n('Survey')
    },
    get description() {
        return i18n('SideView, PlanView and Table View')
    },
    queryHandlerKind: type,
    config: {
        view: 'table'
    },
    impl: reactWidgetWrapper<SurveyState, SurveyEvent, SurveyConfig>(SurveyChart, trajectoryReducer)
})

widgetsService.policies(type, {
    layers: 1,
    allowYAxisConfig: false,
    allowGroupedYAxis: false,
    defaultReducer: '@latest',
    handleOwnMissingData: true
})

fixDisplayUnit(type)

addNewEditor(
    {
        type,
        order: 11,
        label: i18n('Survey'),
        description: i18n('Visualize Section view, Plan view and Survey of a well trajectory'),
        thumbnail: thumbnail
    },
    [
        <Fields name={'channels'}>
            <AssetSelector label={'Asset'} editorOnly={true} />
            <ObjectSelector label={'Trajectory'} objectType={'trajectory'} />
        </Fields>,
        <Fields>
            <TrajectorySelectView configField={'view'} />
        </Fields>
    ]
)

// That is important to handle the "edit mode" different from "view mode"
LiveApi.Interceptor.widget.requests.register(function (req, params) {
    if (
        (req.kind === 'bha' || req.kind === 'survey' || req.kind === 'wbs') &&
        (document.location + '').match(/mode=edit/)
    ) {
        req.config.editMode = params.mode === 'edit'
    }

    return req
})
